import { createApp } from 'vue'
import options from './PersonalFundraisingDashboard.options'

const el = '.kb-component--personal-fundraising-dashboard'
const FALLBACK_CREATE_URL = '#'

const parseJson = (value, fallback = null) => {
    if (!value) {
        return fallback
    }
    try {
        return JSON.parse(value)
    } catch (err) {
        console.error('PersonalFundraisingDashboard: invalid JSON in dataset', err)
        return fallback
    }
}

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((dashboardDOM) => {
            const createUrl = dashboardDOM.dataset.createUrl || FALLBACK_CREATE_URL
            const rawUserProfileId = dashboardDOM.dataset.userProfileId
            const userProfileId =
                rawUserProfileId && rawUserProfileId.trim() !== ''
                    ? rawUserProfileId.trim()
                    : null
            const rawCampaignAreaId = dashboardDOM.dataset.campaignAreaId
            const campaignAreaId =
                rawCampaignAreaId && rawCampaignAreaId.trim() !== ''
                    ? rawCampaignAreaId.trim()
                    : null
            const rawPageId = dashboardDOM.dataset.pageId
            const pageId =
                rawPageId && rawPageId.trim() !== '' ? rawPageId.trim() : null
            const collections = parseJson(dashboardDOM.dataset.collections, null)
            const isMindegave =
                dashboardDOM.dataset.isMindegave === 'true' ||
                dashboardDOM.hasAttribute('is-mindegave')

            options.template = dashboardDOM.outerHTML

            const component = createApp(options, {
                createUrl,
                userProfileId,
                campaignAreaId,
                pageId,
                collections,
                isMindegave
            }).use(Store)
            component.mount(dashboardDOM)
        })
    }
}
